import { render, staticRenderFns } from "./PgaSkeletonLoader.vue?vue&type=template&id=7aa205aa&"
import script from "./PgaSkeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./PgaSkeletonLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aa205aa')) {
      api.createRecord('7aa205aa', component.options)
    } else {
      api.reload('7aa205aa', component.options)
    }
    module.hot.accept("./PgaSkeletonLoader.vue?vue&type=template&id=7aa205aa&", function () {
      api.rerender('7aa205aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaSkeletonLoader.vue"
export default component.exports